import {adminTraineeFoodLogGetTraineeFoodLog} from '../api/generated';

// Migrated to the OpenAPI client (GET /admin/food-log/trainee/{traineeId}/{weekDate} ->
// TraineeWeeklyFoodLogResponse). Old returned {success, data: response.data}; the SDK's
// `data` IS that body, so the return shape is unchanged (callers read response.data).
export const getTraineeFoodLog = async (traineeId, weekDate) => {
    try {
        const {data, error} = await adminTraineeFoodLogGetTraineeFoodLog({
            path: {traineeId, weekDate},
        });
        if (error) {
            throw error;
        }
        return {
            success: true,
            data
        };
    } catch (error) {
        console.error('Error fetching food log:', error);
        return {
            success: false,
            message: error.response?.data?.message || "שגיאה בטעינת יומן האכילה",
            data: null
        };
    }
};
